<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.33334 11.6673L4.64554 16.9161C4.68245 17.0638 4.7009 17.1376 4.72273 17.202C4.93598 17.8316 5.50294 18.2743 6.16544 18.3284C6.23326 18.334 6.30934 18.334 6.4615 18.334C6.65204 18.334 6.74731 18.334 6.82757 18.3262C7.62083 18.2493 8.24862 17.6215 8.32556 16.8282C8.33334 16.748 8.33334 16.6527 8.33334 16.4621V4.58399M15.4167 11.2507C17.0275 11.2507 18.3333 9.94482 18.3333 8.33399C18.3333 6.72316 17.0275 5.41733 15.4167 5.41733M8.54167 4.58399H5.41667C3.3456 4.58399 1.66667 6.26293 1.66667 8.33399C1.66667 10.4051 3.3456 12.084 5.41667 12.084H8.54167C10.0137 12.084 11.8144 12.8731 13.2036 13.6304C14.014 14.0722 14.4192 14.2931 14.6846 14.2605C14.9308 14.2304 15.1168 14.1199 15.2611 13.9182C15.4167 13.7008 15.4167 13.2657 15.4167 12.3954V4.27256C15.4167 3.40232 15.4167 2.9672 15.2611 2.74973C15.1168 2.54808 14.9308 2.43758 14.6846 2.40743C14.4192 2.37493 14.014 2.59582 13.2036 3.03762C11.8144 3.79492 10.0137 4.58399 8.54167 4.58399Z"
      stroke="#EAF7F6"
      stroke-width="1.67"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
